import { Navigate, generatePath } from 'react-router';

import { useTypedParams } from '@sorare/routing';
import { MLB_TEAMS_SLUG } from '@sorare/core/src/constants/__generated__/routes';

import type { PageParams } from './__generated__/routeParams.ts';

const BaseballTeamPlayers = () => {
  const { slug } = useTypedParams<PageParams>();

  return <Navigate to={generatePath(MLB_TEAMS_SLUG, { slug })} />;
};

export default BaseballTeamPlayers;
